import { render, staticRenderFns } from "./editWorksheetDialog.vue?vue&type=template&id=87c1f468&scoped=true"
import script from "./editWorksheetDialog.vue?vue&type=script&lang=js"
export * from "./editWorksheetDialog.vue?vue&type=script&lang=js"
import style0 from "./editWorksheetDialog.vue?vue&type=style&index=0&id=87c1f468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c1f468",
  null
  
)

export default component.exports